// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixStores from 'wix-stores';

$w.onReady(function () {
	/*var today = new Date(), endDate = new Date("2020-12-01 10:00:00 PM");
	var diffMs = (endDate - today); // milliseconds between now & Christmas
	var diffDays = Math.floor(diffMs / 86400000);
	var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
	var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

	$w("#columnHeaderText").text = "SALE CLOSES IN " + diffDays + " DAYS " + diffHrs + " HOURS " + diffMins + " MINUTES";*/

	// wixStores.onCartChanged((cart) => {
	// 	const cartLineItems = cart.lineItems;
	// 	console.log('cart change detected - cartLineItems =', cartLineItems);
	// });
});
